/**
 * Dịch một lỗi bất kỳ thành câu người dùng đọc được.
 *
 * Thay cho `getErrorMessage()` cũ. Tách thành hook vì câu lỗi giờ đi qua
 * catalog, mà catalog chỉ đọc được trong React — và nhờ vậy dải lỗi đang hiện
 * **đổi ngôn ngữ ngay** khi người dùng chuyển, không đợi tải lại.
 */
import { useCallback } from 'react';

import { giaiLoi } from '../lib/errors';
import { tachLoiHanMuc } from '../lib/loi-han-muc';
import { useT } from '../i18n';
import { useMoTaHanMuc } from './useMoTaHanMuc';

export function useLoi(): (err: unknown) => string {
  const { t } = useT();
  const { dongGon } = useMoTaHanMuc();

  return useCallback(
    (err: unknown) => {
      const kq = giaiLoi(err);
      if (kq.kieu === 'khoa') return t(kq.khoa);
      // Câu hết hạn mức do nền tảng viết nên dịch được và thu gọn được (toast, dải lỗi một dòng).
      const hanMuc = tachLoiHanMuc(kq.cau);
      // Câu khác của backend tới lúc chạy, không có trong catalog — giữ nguyên văn.
      return hanMuc ? dongGon(hanMuc) : kq.cau;
    },
    [t, dongGon],
  );
}
